var WorkExperience = [
    {
        "name": "Refactory",
        "period": "September 2020 - Present",
        "description": "Handle backend development in project(s), especially Golang",
        "title": "Backend Engineer",
        "url": "https://refactory.id/",
    },
    {
        "name": "Internship at PT LEN Industri",
        "period": "July - August 2018",
        "description": "Learning about one of Single Board Computer (SBC) called Beaglebone Black. I explored how Beaglebone Black can communicate with other devices using I2C and Serial, how it can connect to the internet with usb cable, how it can read raw data from sensors, and combine all of them.",
        "title": "Internship in Defense Electronics Department",
        "url": "https://www.len.co.id/",
    },
]

export default WorkExperience;


// WEBPACK FOOTER //
// ./src/data/WorkExperience.js